export default {
  label: 'Definir como domínio principal',
  successNotification: 'Domínio definido com sucesso.',
  failedNotification: 'Erro ao definir domínio principal.'
}
